import { createFileRoute } from "@tanstack/react-router";
import { PageHero, ReviewCard, GoogleReviewsButton, FinalCta } from "@/components/sections";
import { reviews } from "@/lib/site-data";
import { pageHead, breadcrumbLd } from "@/lib/seo";

const TITLE = "Customer Reviews | 406 Mobile Mechanic, Great Falls MT";
const DESC = "Read what Montana drivers say about Josh and 406 Mobile Mechanic — real Google reviews from customers in Great Falls and beyond.";

export const Route = createFileRoute("/reviews")({
  head: () => pageHead("/reviews", TITLE, DESC, [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Reviews", path: "/reviews" }])]),
  component: ReviewsPage,
});

function ReviewsPage() {
  return (
    <main>
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Reviews" }]}
        eyebrow="Google reviews"
        title={<>Mobile Mechanic Reviews from <span className="text-primary">Great Falls, MT</span></>}
        intro="What Montana drivers say about Josh, word for word from Google."
        photo="towing"
      />
      <section className="bg-background py-24" aria-label="Customer reviews">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="grid gap-6 md:grid-cols-2">
            <ReviewCard r={reviews.mccleary} featured />
            <ReviewCard r={reviews.cindy} />
            <ReviewCard r={reviews.deb} />
          </div>
          <div className="mt-10 text-center"><GoogleReviewsButton /></div>
        </div>
      </section>
      <FinalCta />
    </main>
  );
}
